import { api } from "@api/api";
import { AmigobotDoctor } from "@modules/prescribers/types";

import { ListAmigobotDoctorsQueryFilters } from "./types";

/**
 * A API do AmigoBot não paginha nem filtra a lista de médicos, então a
 * busca por texto e a resolução de ids selecionados são feitas no client.
 */
export async function getAmigobotDoctorsService(
  filters?: ListAmigobotDoctorsQueryFilters
): Promise<AmigobotDoctor[]> {
  try {
    const { data } = await api.get<{ data: AmigobotDoctor[] }>(
      "v1/telemedicine/amigobot/doctors/"
    );

    let results = data.data.map((doctor) => ({
      ...doctor,
      name: doctor.specialty ? `${doctor.name} - ${doctor.specialty}` : doctor.name,
    }));

    if (filters?.ids && filters.ids.length > 0) {
      const ids = filters.ids.map(String);
      results = results.filter((doctor) => ids.includes(String(doctor.id)));
    } else if (filters?.search) {
      const search = filters.search.toLowerCase();
      results = results.filter((doctor) => doctor.name.toLowerCase().includes(search));
    }

    return results;
  } catch (error) {
    console.error("Error fetching amigobot doctors:", error);
    throw error;
  }
}
